export default "__VITE_ASSET__61c069f8__$_?component__"